import React from 'react'
import { Lightbulb } from "lucide-react";

function AiDisclaimer() {
  return (
<div className="w-full font-plexsans text-xs mt-5 mx-auto lg:mx-0">
  <div className="flex items-start gap-2 text-[rgba(20,33,61,.55)] border-t border-[rgba(20,33,61,.1)] pt-3.5">

    <Lightbulb
      size={16}
      className="text-tan shrink-0 mt-0.5"
    />

    <div>
      <span className="font-medium text-navy">Disclaimer:</span>{" "}
      AI insights may be inaccurate and should not replace legal advice.
    </div>

  </div>
</div>
  )
}

export default AiDisclaimer
